import { render } from "./AccountDetails.vue?vue&type=template&id=1b229560&scoped=true&ts=true"
import script from "./AccountDetails.vue?vue&type=script&lang=ts"
export * from "./AccountDetails.vue?vue&type=script&lang=ts"

import "./AccountDetails.vue?vue&type=style&index=0&id=1b229560&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b229560"]])

export default __exports__